// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Br9P","tabsBox":"styles_tabsBox__wxWlg","createButton":"styles_createButton__31q7L"};